import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import ApiTokenNameEditor from './api_token_name_editor';
import CancelApiTokenEdit from 'actions/api_tokens/cancel_api_token_edit';
import ClickToEditField from 'components/common/click_to_edit_field';
import connect from 'components/lib/connect';
import RenameApiToken from 'actions/api_tokens/rename_api_token';

const ApiTokenName = ClickToEditField(ApiTokenNameDisplay, ApiTokenNameEditor);

ApiTokenName.propTypes.value = PropTypes.string;

export { ApiTokenName };

/**
 * ApiTokenNameContainer
 */
export default connect(mapStateToProps, mapExecuteToProps)(ApiTokenName);

function mapStateToProps({ getProvider }, { id, value }) {
  let apiTokensProvider = getProvider('apiTokens');

  return {
    errors: getErrors(),
    isResponsePending: apiTokensProvider.isPending(id),
    value,
  };

  function getErrors() {
    return apiTokensProvider
      .getErrors(id)
      .filter(err => err.attr === 'name')
      .map(err => err.detail);
  }
}

function mapExecuteToProps(executeAction, { id }) {
  return {
    onCancelEdit: () => executeAction(CancelApiTokenEdit, id),
    onSave: name => executeAction(RenameApiToken, { id, name }),
  };
}

/**
 * ApiTokenNameDisplay
 */
export function ApiTokenNameDisplay({ isDisabled, onClick, value }) {
  let className = classnames('apiTokenNameDisplay', {
    'apiTokenNameDisplay-disabled': isDisabled,
  });
  return (
    <div className={className} onClick={onClick}>
      {value}
    </div>
  );
}

ApiTokenNameDisplay.propTypes = {
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_token_name.jsx